import EdTaskBoardManageState from '../ed-wbo-drawer-manage-state';
import EdTaskBoardRecreateShapes from '../ed-wbo-drawer-recreate-shapes';
import WboDrawerTools from '@/components/common/ed-board/ed-board-tools/ed-wbo-drawer/wbo-drawer-tools';
import { BoardAction, BoardActionType } from '../board-actions.model';
import BoardTool from '@/components/common/ed-board/ed-board-tools/board-tool.interface';

export default class EdWboDrawerRedo {

  private recreateShapes : EdTaskBoardRecreateShapes;
  private manageState: EdTaskBoardManageState;
  private wboDrawerTools: WboDrawerTools;

  private addInverseActionToUndoStack(boardAction: BoardAction): void {
    const inverseActionType: BoardActionType = BoardAction.getInverseActionType(boardAction.actionType);    
    this.manageState.addBoardActionToUndoStack(boardAction.annotations, inverseActionType, boardAction.actionParams, true);
  }

  private redoAction: Function = (): void => {
    const boardAction: BoardAction = this.manageState.getLastRedoBoardAction();

    if (BoardAction.isValidBoardAction(boardAction)) {
      this.addInverseActionToUndoStack(boardAction);
      if (boardAction.annotations.length > 1) {
        this.recreateShapes.processSeveralAnnotations(
          boardAction.actionType,
          boardAction.annotations.map(annotation => this.manageState.getBoardActionObjectByActionType(annotation, boardAction.actionType)),
          this.manageState.getAnnotationChildren()
        );
      } else {
        const annotation = boardAction.annotations[0];
        const children: any[] = (annotation._children && Array.isArray(annotation._children))
          ? annotation._children
          : this.manageState.getAnnotationChildren().get(annotation.id);
        this.recreateShapes.processBoardAction(
          boardAction.actionType, 
          this.manageState.getBoardActionObjectByActionType(annotation, boardAction.actionType),
          children);
      }
    }
  }

  private redoTool : BoardTool = { //The new tool
    name: 'Redo',
    listeners: {},
    oneTouch: true,
    draw: (data: any) => true,
    onstart: this.redoAction,
    icon: '/assets/tools/undo-redo/redo/redo.svg',
    mouseCursor: 'crosshair',
    showMarker: true
  }

  constructor(tools: WboDrawerTools, manageState: EdTaskBoardManageState, recreateShapes : EdTaskBoardRecreateShapes) {
    this.wboDrawerTools = tools;
    this.wboDrawerTools.add(this.redoTool);
    this.recreateShapes = recreateShapes;
    this.manageState = manageState;
  }
}
